/* EBH — página de favoritos (2026-09-12)
   ---------------------------------------------------------------------------
   A página chega da CDN vazia. Aqui lê-se a lista do navegador e pede-se cada
   peça à secção `ebh-wishlist-item`, que devolve as duas vistas já em Liquid —
   preço do mercado certo, stock real e as frases nas nove línguas.

   ⚠️ Uma peça guardada pode ter sido despublicada ou apagada entretanto: o
      pedido devolve 404 e a peça sai da lista em silêncio. Deixá-la lá deixava
      um buraco no mosaico que ninguém conseguia tirar.

   ⚠️ «Baixou de preço» compara com `preco_guardado`, o preço do dia em que a
      peça foi guardada. «Voltou ao stock» compara com `disponivel_visto`, o
      último estado que vimos. Os dois vivem no registo e actualizam-se aqui.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var root = document.querySelector('[data-ebh-wl-page]');
  if (!root || !window.EBHWishlist) return;

  var WL = window.EBHWishlist;
  var T = {};
  try { T = JSON.parse(root.querySelector('[data-wl-i18n]').textContent); } catch (e) { T = {}; }

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  var grid = $('[data-wl-grid]');
  var list = $('[data-wl-list]');
  var loading = $('[data-wl-loading]');
  var empty = $('[data-wl-empty]');
  var tools = $('[data-wl-tools]');

  /* Lista partilhada: /pages/wishlist?l=handle1,handle2 — vê-se, não se mexe. */
  var partilhada = null;
  try {
    var q = new URLSearchParams(window.location.search).get('l');
    if (q) partilhada = q.split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 200);
  } catch (e) { partilhada = null; }

  /* ------------------------------------------------------------------ dinheiro */
  function formatMoney(cents, format) {
    var f = format || '{{amount}}';
    var val = (cents || 0) / 100;
    function parts(dec, milhar, dp) {
      var n = val.toFixed(dp);
      var p = n.split('.');
      var inteiro = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, milhar);
      return dp > 0 ? inteiro + dec + p[1] : inteiro;
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return parts('.', ',', 2);
        case 'amount_no_decimals': return parts('.', ',', 0);
        case 'amount_with_comma_separator': return parts(',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return parts(',', '.', 0);
        case 'amount_with_apostrophe_separator': return parts('.', "'", 2);
        case 'amount_with_space_separator': return parts(',', ' ', 2);
        case 'amount_no_decimals_with_space_separator': return parts(',', ' ', 0);
        default: return parts('.', ',', 2);
      }
    });
  }
  var money = function (c) { return formatMoney(c, T.money_format); };

  function plural(n, one, other) {
    return String(n === 1 ? (one || '') : (other || '')).replace('{{ n }}', n).replace('{{n}}', n);
  }
  function fill(str, vars) {
    return String(str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      return vars[k] === undefined ? '' : vars[k];
    });
  }

  /* ------------------------------------------------------------------- pedidos */
  var BASE = root.dataset.urlItem || '/products';

  function pedir(handle) {
    var url = BASE.replace(/\/$/, '') + '/' + encodeURIComponent(handle) + '?section_id=ebh-wishlist-item';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .catch(function () { return null; });
  }

  /* Seis de cada vez: uma lista de 50 peças não deve abrir 50 ligações. */
  function emFila(handles, trabalho) {
    var i = 0, out = new Array(handles.length), vivos = [];
    function proximo() {
      if (i >= handles.length) return Promise.resolve();
      var k = i++;
      return trabalho(handles[k]).then(function (r) { out[k] = r; return proximo(); });
    }
    for (var n = 0; n < Math.min(6, handles.length); n++) vivos.push(proximo());
    return Promise.all(vivos).then(function () { return out; });
  }

  /* --------------------------------------------------------------------- estado */
  var registos = [];   // o que está guardado, por handle
  var pecas = [];      // { handle, tile, row, preco, disp }

  function registoDe(handle) {
    for (var i = 0; i < registos.length; i++) {
      if (registos[i].handle === handle) return registos[i];
    }
    return null;
  }

  function selo(classe, texto) {
    var s = document.createElement('span');
    s.className = classe;
    s.textContent = texto;
    return s;
  }

  function marcarMudancas(p) {
    var reg = registoDe(p.handle);
    if (!reg || partilhada) return;

    var baixou = reg.preco_guardado > 0 && p.preco > 0 && p.preco < reg.preco_guardado;
    var voltou = p.disp && reg.disponivel_visto === false;

    if (baixou) {
      var pct = Math.round((1 - p.preco / reg.preco_guardado) * 100);
      if (pct > 0) {
        p.baixou = pct;
        /* O mosaico não tem selos (só fotografias) — o slot pode não existir. */
        var alvoT = p.tile.querySelector('[data-wl-tag-slot]');
        if (alvoT) alvoT.appendChild(selo('ebh-wl-tag is-drop', fill(T.price_drop, { pct: pct })));
        p.row.querySelector('[data-wl-chip-slot]').appendChild(
          selo('ebh-wl-chip is-drop', fill(T.price_drop, { pct: pct })));
        var pr = p.row.querySelector('.ebh-wl-row__pr');
        if (pr && !pr.querySelector('del')) {
          var d = document.createElement('del');
          d.textContent = money(reg.preco_guardado);
          pr.insertBefore(d, pr.firstChild);
        }
      }
    } else if (voltou) {
      var alvoB = p.tile.querySelector('[data-wl-tag-slot]');
      if (alvoB) alvoB.appendChild(selo('ebh-wl-tag is-back', T.back_in_stock));
      p.row.querySelector('[data-wl-chip-slot]').appendChild(selo('ebh-wl-chip is-back', T.back_in_stock));
    }

    /* O estado visto actualiza-se; o preço guardado NÃO — é ele a régua. */
    reg.preco = p.preco;
    reg.disponivel_visto = p.disp;
  }

  /* ------------------------------------------------------------------ desenhar */
  function formaDoMosaico() {
    var tiles = grid.querySelectorAll('[data-wl-tile]');
    grid.classList.toggle('is-curta', tiles.length < 5);
    tiles.forEach(function (t, i) {
      t.classList.remove('is-big');
      /* Só a primeira guardada fica grande. Houve também uma peça ALTA (duas
         filas, uma coluna) e foi retirada: com a altura a sair da largura, uma
         coluna por duas filas dá uma tira de 0,39 de proporção e a fotografia,
         que é 4:5, era cortada dos dois lados.
         Com menos de cinco peças não há peça grande — o desencontro só faria
         buracos numa fila que ainda nem está cheia. */
      if (tiles.length >= 5 && i === 0) t.classList.add('is-big');
    });
  }

  function contas() {
    var vivos = pecas.filter(function (p) { return p.node.isConnected; });
    var total = 0, disp = 0, totalDisp = 0, fora = 0, baixaram = 0;
    vivos.forEach(function (p) {
      total += p.preco;
      if (p.disp) { disp++; totalDisp += p.preco; } else { fora++; }
      if (p.baixou) baixaram++;
    });
    var n = vivos.length;

    $('[data-wl-sub]').textContent = n
      ? plural(n, T.pieces_one, T.pieces_other) + ' · ' + money(total)
      : '';

    var pc = $('[data-wl-panel-count]');
    if (pc) pc.textContent = plural(n, T.pieces_one, T.pieces_other);
    var pt = $('[data-wl-panel-total]');
    if (pt) pt.textContent = money(total);
    var pa = $('[data-wl-panel-avail]');
    if (pa) pa.textContent = disp + ' · ' + money(totalDisp);

    $$('[data-wl-take]').forEach(function (b) {
      b.disabled = disp === 0;
      b.textContent = disp === 0
        ? T.take_none
        : fill(T.take, { n: disp, total: money(totalDisp) });
    });

    var foot = $('[data-wl-foot]');
    if (foot) {
      foot.hidden = n === 0;
      $('[data-wl-note]').textContent = fora ? plural(fora, T.note_out_one, T.note_out_other) : '';
    }

    var tabAll = $('[data-wl-tab="all"]');
    if (tabAll) tabAll.textContent = fill(T.tab_all, { n: n });
    var tabDrop = $('[data-wl-tab="drop"]');
    if (tabDrop) { tabDrop.hidden = baixaram === 0; tabDrop.textContent = fill(T.tab_drop, { n: baixaram }); }
    var tabOut = $('[data-wl-tab="out"]');
    if (tabOut) { tabOut.hidden = fora === 0; tabOut.textContent = fill(T.tab_out, { n: fora }); }

    var convite = $('[data-wl-nudge]');
    if (convite) convite.hidden = n === 0;

    if (n === 0) mostrarVazio();
    formaDoMosaico();
  }

  function mostrarVazio() {
    empty.hidden = false;
    var convite = $('[data-wl-nudge]');
    if (convite) convite.hidden = true;
    tools.hidden = true;
    $$('[data-wl-view-pane]').forEach(function (p) { p.hidden = true; });
  }

  /* --------------------------------------------------------------------- vista */
  function aplicarVista(v) {
    $$('[data-wl-view-pane]').forEach(function (p) { p.hidden = p.dataset.wlViewPane !== v; });
    $$('[data-wl-view]').forEach(function (b) {
      var on = b.dataset.wlView === v;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  root.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-wl-view]');
    if (b) { WL.setView(b.dataset.wlView); aplicarVista(b.dataset.wlView); return; }

    var rm = ev.target.closest('[data-wl-remove]');
    if (rm) {
      var h = rm.dataset.wlRemove;
      if (!partilhada) {
        WL.remove(h);
        /* O «tirar» daqui não passa pelo coração da grelha: sem esta linha,
           desistir de uma peça na própria lista não deixava rasto nenhum. */
        if (WL.evento) WL.evento('tirar', { handle: h, superficie: 'lista' });
      }
      pecas.forEach(function (p) { if (p.handle === h) p.node.remove(); });
      contas();
      return;
    }

    var add = ev.target.closest('[data-wl-add]');
    if (add) {
      var dono = null;
      pecas.forEach(function (p) { if (p.row.contains(add) || p.tile.contains(add)) dono = p; });
      aoCesto([{ id: add.dataset.wlAdd, quantity: 1 }], add, dono ? [dono.handle] : []);
      return;
    }

    var take = ev.target.closest('[data-wl-take]');
    if (take) {
      var itens = [], quais = [];
      pecas.forEach(function (p) {
        if (!p.node.isConnected || !p.disp) return;
        var btn = p.row.querySelector('[data-wl-add]');
        if (btn) { itens.push({ id: btn.dataset.wlAdd, quantity: 1 }); quais.push(p.handle); }
      });
      if (itens.length) aoCesto(itens, take, quais);
      return;
    }

    if (ev.target.closest('[data-wl-share]')) { partilhar(ev.target.closest('[data-wl-share]')); return; }
    if (ev.target.closest('[data-wl-adopt]')) { adoptar(); return; }

    var tab = ev.target.closest('[data-wl-tab]');
    if (tab) { filtrar(tab); return; }
  });

  function filtrar(tab) {
    $$('[data-wl-tab]').forEach(function (t) { t.classList.toggle('is-on', t === tab); });
    var qual = tab.dataset.wlTab;
    pecas.forEach(function (p) {
      if (!p.node.isConnected) return;
      var mostra = qual === 'all'
        || (qual === 'drop' && p.baixou)
        || (qual === 'out' && !p.disp);
      p.row.hidden = !mostra;
    });
  }

  /* (2026-09-16) `handles` só serve para medir: é o que transforma «alguém
     carregou no botão» em «que peça guardada é que foi ao cesto». Ver
     wlEvento em ebh-spine/src/index.js. */
  function aoCesto(itens, btn, handles) {
    var antes = btn.textContent;
    btn.disabled = true;
    if (WL.evento) {
      (handles || []).forEach(function (h) {
        WL.evento('carrinho', { handle: h, superficie: 'lista' });
      });
    }
    fetch(root.dataset.urlCartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: itens })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      /* O tema abre a gaveta do cesto neste evento; sem ele, vai-se ao cesto. */
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      btn.disabled = false;
      btn.textContent = antes;
    }).catch(function () {
      window.location.href = root.dataset.urlCart || '/cart';
    });
  }

  function partilhar(btn) {
    var handles = pecas.filter(function (p) { return p.node.isConnected; })
                       .map(function (p) { return p.handle; });
    var url = window.location.origin + window.location.pathname + '?l=' + handles.join(',');
    var label = btn.querySelector('[data-wl-share-label]') || btn;
    function feito() {
      label.textContent = T.share_copied;
      setTimeout(function () { label.textContent = T.share; }, 2400);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(feito, function () { window.prompt('', url); });
    } else {
      window.prompt('', url);
    }
  }

  function adoptar() {
    pecas.forEach(function (p) {
      if (!p.node.isConnected) return;
      WL.add({ handle: p.handle, preco_guardado: p.preco, disponivel_visto: p.disp });
    });
    window.location.href = window.location.pathname;
  }

  /* -------------------------------------------------------------------- arranque */
  function arrancar() {
    registos = WL.all();
    var handles = partilhada || registos.map(function (r) { return r.handle; });

    if (!handles.length) { mostrarVazio(); return; }

    loading.hidden = false;
    $('[data-wl-shared]').hidden = !partilhada;

    emFila(handles, pedir).then(function (htmls) {
      loading.hidden = true;
      var caidas = [];

      htmls.forEach(function (html, i) {
        var handle = handles[i];
        if (!html) { caidas.push(handle); return; }
        var box = document.createElement('div');
        box.innerHTML = html;
        var item = box.querySelector('[data-ebh-wl-item]');
        if (!item) { caidas.push(handle); return; }

        var tile = item.querySelector('[data-wl-tile]');
        var row = item.querySelector('[data-wl-row]');
        if (!tile || !row) { caidas.push(handle); return; }

        if (partilhada) {
          tile.querySelectorAll('[data-wl-remove]').forEach(function (n) { n.remove(); });
          row.querySelectorAll('[data-wl-remove]').forEach(function (n) { n.remove(); });
        }

        var p = {
          handle: handle, tile: tile, row: row,
          preco: parseInt(tile.dataset.preco || '0', 10) || 0,
          disp: tile.dataset.disp === 'true',
          baixou: 0,
          /* `node` é o par: apagar a peça tem de tirar as duas vistas de uma vez */
          node: null
        };
        p.node = { isConnected: true, remove: function () { tile.remove(); row.remove(); this.isConnected = false; } };

        grid.appendChild(tile);
        list.appendChild(row);
        pecas.push(p);
        marcarMudancas(p);
      });

      /* Peças que já não existem saem da lista guardada, não só do ecrã. */
      if (caidas.length && !partilhada) caidas.forEach(function (h) { WL.remove(h); });
      if (!partilhada) gravarRegistos();

      if (!pecas.length) { mostrarVazio(); return; }

      empty.hidden = true;
      tools.hidden = false;
      aplicarVista(WL.view());
      contas();

      /* Uma linha por visita à lista, depois de ela existir mesmo no ecrã. É o
         denominador honesto do «quantos dos que guardam voltam cá»; contá-la no
         arranque contava também as listas vazias e as que não chegaram a pintar.
         A lista partilhada por link fica de fora — não é a lista de ninguém. */
      if (WL.evento && !partilhada) WL.evento('ver_lista', { superficie: 'lista' });
    });
  }

  /* Grava de volta os registos com a disponibilidade actualizada, sem passar
     pelo add/remove (que mexeriam na ordem e levantariam lápides). O
     `preco_guardado` NÃO se toca aqui: é ele a régua do «baixou de preço». */
  function gravarRegistos() {
    var e = WL.estado();
    e.lista = registos;
    WL.poe(e);
  }

  arrancar();
})();
